export { CurencyYen as default } from './CurencyYen';
